import { useNotification } from '@/containers'
import ImageOptimize from '../ImageOptimize'

export const HeaderLogo = () => {
  const { systemConfig } = useNotification()
  return (
    <div className='inline-flex'>
      <button className='flex gap-1 items-center outline-0'>
        <ImageOptimize
          loading='eager'
          // Không `priority`: logo SVG 57x40 không phải LCP, preload kèm
          // fetchpriority=high chỉ chiếm ưu tiên của ảnh banner/LCP.
          className='h-full w-auto max-w-[200px]'
          alt={systemConfig?.websiteBrandName || 'Logo'}
          src={systemConfig?.companyLogoHeaderMobile || '/Logo_NK.svg'}
          width={57}
          height={40}
        />
      </button>
    </div>
  )
}
